export default [
  {
    path: '/admin/organization/mt/orgTimeslices',
    // path: '/admin/timeslices',
    name: 'TimeSlices',
    component: () => import('./timeslices/TimeSlices.vue'),
    meta: { requiresAuth: true, requiresAdmin: true },
  },
  {
    path: '/admin/organization/mt/orgPatches',
    name: 'Patches',
    component: () => import('./patches/Patches.vue'),
    meta: { requiresAuth: true, requiresAdmin: true },
  },
  {
    path: '/admin/organization/mt/orgWatchLists',
    name: 'WatchLists',
    component: () => import('./watchlists/WatchLists.vue'),
    meta: { requiresAuth: true, requiresAdmin: true },
  },
];
